var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_59",
    "data-name": "Mask Group 59",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(253.714 9.715)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M16.521,5.978l-4.5-4.5a.584.584,0,0,0-.45-.193H5.143A1.29,1.29,0,0,0,3.857,2.571V18a1.29,1.29,0,0,0,1.286,1.286H15.428A1.29,1.29,0,0,0,16.714,18V6.428A.584.584,0,0,0,16.521,5.978Zm-4.95-3.15,3.6,3.6h-3.6ZM15.428,18H5.143V2.571h5.143V6.428a1.29,1.29,0,0,0,1.286,1.286h3.857Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosting);
export default __webpack_public_path__ + "static/media/posting.376baa5453eb8596de46846325c4aff6.svg";
export { ForwardRef as ReactComponent };